<template/>

<script>
export default {
  props: {
    interceptor: {
      type: Boolean,
      required: true
    }
  },
  
  mounted() {
    this.$emit("isValid", this.interceptor);
  },
  
  watch: {
    interceptor(newVal) {
      this.$emit('isValid', newVal);
    }
  }
}
</script>